module.exports = __webpack_public_path__ + "img/sweden.5cf7691.webp";